import Canvas from './Canvas';

// A grayscale blurred circle image that will be used for drawing points.
export class CircleCanvas extends Canvas {
  static BLUR_RATIO = 0.375;
  static DEFAULT_DIAMETER = 25;

  constructor(diameter: number) {
    // Make circle size calculations
    const safeDiameter = diameter > 0 ? diameter : CircleCanvas.DEFAULT_DIAMETER;

    super({ width: safeDiameter, height: safeDiameter });

    // Draw the circle once.
    this._draw();
  }

  private _draw(): void {
    const ctx = this.ctx;

    if (ctx) {
      const diameter = this.getWidth();
      const outerRadius = diameter / 2;
      const innerRadius = outerRadius * (1 - CircleCanvas.BLUR_RATIO);

      // Clear the canvas.
      ctx.clearRect(0, 0, diameter, diameter);

      // Configure the context before drawing.
      ctx.shadowOffsetX = diameter;
      ctx.shadowOffsetY = diameter;
      ctx.shadowBlur = outerRadius * CircleCanvas.BLUR_RATIO;
      ctx.shadowColor = 'black';

      // Draw the filled circle on the canvas.
      ctx.beginPath();
      ctx.arc(-outerRadius, -outerRadius, innerRadius, 0, Math.PI * 2, true);
      ctx.closePath();
      ctx.fill();
    }
  }

  // Redraw the circle with its new dimensions after updating the canvas size.
  public update(diameter: number): void {
    const safeDiameter = diameter > 0 ? diameter : CircleCanvas.DEFAULT_DIAMETER;

    this.setWidth(safeDiameter);
    this.setHeight(safeDiameter);

    this._draw();
  }
}

export default CircleCanvas;
